"use strict";

exports.__esModule = true;
exports.ReportKindSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _excluded = ["translator", "placeholder"];
var _class, _ReportKindSelector;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ReportKindSelector = exports.ReportKindSelector = (0, _Core.withTranslator)(_class = (_ReportKindSelector = /*#__PURE__*/function (_Component) {
  function ReportKindSelector() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportKindSelector, _Component);
  var _proto = ReportKindSelector.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translator = _this$props.translator,
      placeholder = _this$props.placeholder,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "ReportKindSelector",
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", extra, /*#__PURE__*/_react["default"].createElement("option", null, placeholder || translator.translate("ReportKindSelector.placeholder.label", "Select")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "singleDevice"
    }, translator.translate("ReportKindSelector.singleDevice.label", "Single Device Report")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "multiDevice"
    }, translator.translate("ReportKindSelector.multiDevice.label", "Report for Multiple Devices"))));
  };
  return ReportKindSelector;
}(_react.Component), _ReportKindSelector.defaultProps = {
  translator: undefined
}, _ReportKindSelector)) || _class;